import { render } from "./FairPrice.vue?vue&type=template&id=38eae930&scoped=true"
import script from "./FairPrice.vue?vue&type=script&lang=js"
export * from "./FairPrice.vue?vue&type=script&lang=js"

import "./FairPrice.vue?vue&type=style&index=0&id=38eae930&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38eae930"]])

export default __exports__